var path = 'app/designationEditButton/designationEditButton.tpl.html';
var html = "<a id=editDesignationButton href=\"\" ng-click=$ctrl.editPage() class=\"btn btn-default\" ng-if=$ctrl.showEditButton translate> Edit Page </a> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;